import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getParamusStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/paramus/";
  const description =
    "Find out about your hair transplant options in Paramus with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("paramus", url, description),
    locationPageCrumbs(url, "Paramus"),
  ];
}
